// extracted by mini-css-extract-plugin
module.exports = {"tableLink":"TableFirstColumn_tableLink__2xYMI"};